import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";

export const EmptyNotificationList = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <img alt="img" src="/assets/images/svg/emptyNotification.svg" />
      <div className={styles.textWrapper}>
        <p className={styles.title}>
          {t("lbl_current_notifications_list_empty_state_title")}
        </p>
        <p className={styles.description}>
          {t("lbl_notification_no_notification_description")}
        </p>
      </div>
    </div>
  );
};
